import { hasFlag, setFlag } from "./Flags";
import { addContextListener } from "./PlayerContextListeners";
import { getTotalElementAndSchoolExp } from "./spells/ElementsAndSchools";

export function loadRetirement() {
  addContextListener("RetirementUnlocker", (state) => {
    if (
      !hasFlag(state, "retirement_unlocked") &&
      getTotalElementAndSchoolExp(state) > 10000
    ) {
      return setFlag("retirement_unlocked");
    }
  });
}
